import React from 'react'
import { Card, Drawer, Form, Icon, DatePicker, TimePicker, notification, Button, Select, Tooltip, Input, Row, Col } from 'antd'
import { FaBackward, FaCheck, FaFastForward, FaForward } from 'react-icons/fa'
import { TableComp, FormUtils as GetAllFormFields } from 'sz-react-utils'
import _ from 'lodash'
import { connect } from 'react-redux'
import TextArea from 'antd/lib/input/TextArea'
import Request, { API_URL, LAPI_URL } from '../../request'
import moment from 'moment'

const dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';

const Option = Select.Option

let colorMaping = {
    High: '#eb354b',
    Low: '#0000FF',
    Normal: '#52c41a'
}

let statusMaping = {
    Pending: 'red',
    Complete: 'green',
    Forward: 'blue'
}

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
        md: { span: 8 }
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
        md: { span: 12 }
    }
}

@Form.create()

class TaskViewer extends React.Component {
    state = {
        visible: true,
        disableBTN: false,
        taskCompleteFormVisible: false,
        forwardTaskVisible: false,
        postponeTaskVisible: false,
        taskDetail: {},
        taskCompleteNote: '',
        assignMoreIds: [],
        taskReopenForm: false,
        deadlineTime: ''
    }

    onClose = () => {
        this.setState({
            visible: false
        })
        let $this = this
        setTimeout(() => {
            $this.props.onClose()
        }, 400)
    }

    onTaskCompleteClose = () => {
        this.setState({
            taskCompleteFormVisible: false
        })
    }
    onTaskReopenClose = () => {
        this.setState({
            taskReopenForm: false
        })
    }

    onForwardTaskClose = () => {
        this.setState({
            forwardTaskVisible: false
        })
    }
    onPostponeTaskClose = () => {
        this.setState({
            postponeTaskVisible: false
        })
    }

    async componentDidMount() {
        await this.getNotes();
    }

    getNotes = async () => {
        const { taskId, form } = this.props;
        let response = await Request.getSingleTask({ _id: taskId });
        if (response) {
            this.setState({ taskDetail: response.doc });
        }
    }

    saveNote = (e) => {
        const { dispatch, form, taskId } = this.props
        e.preventDefault()
        this.setState({ disableBTN: true });
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData);
                values.taskId = taskId;
                let x = await Request.saveNote(values);
                if (!x.error) {
                    notification.success({
                        message: 'Note Added successfully'
                    })
                    form.resetFields();
                    this.getNotes();
                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: x.msg
                    })
                }
                this.setState({ disableBTN: false });
            }
        })
    }

    saveMoreAssignee = async () => {
        let assignMoreIds = this.state.assignMoreIds;
        const { taskDetail } = this.state;
        let x = await Request.saveMoreAaaignee({ assignMoreIds, taskId: taskDetail._id });
        if (!x.error) {
        } else {
            notification.error({
                message: 'Error Saving',
                description: x.msg
            })
        }
    }

    render() {
        const {
            form: { getFieldDecorator, setFieldsValue }
        } = this.props;

        const { taskId, allUsers } = this.props;

        const { disableBTN, taskDetail } = this.state;
        let localUser = JSON.parse(localStorage.getItem('user'));
        let userId = localUser._id;

        let assignMoreIds = (taskDetail.assignMoreIds && taskDetail.assignMoreIds.length > 0 ? taskDetail.assignMoreIds : this.state.assignMoreIds);
        const inputTypes = {
            fields: [
                {
                    label: 'Note',
                    key: 'description',
                    required: true,
                    type: 'textArea',
                    rows: 6
                },
                {
                    label: 'Attachment',
                    key: 'image',
                    type: 'file',
                    limit: 2
                }
            ]
        };

        let backgroundColorMap = statusMaping[taskDetail.status];
        let priorityColorMap = colorMaping[taskDetail.priority];

        return (
            <Drawer
                title={
                    <div>
                        {'Task Details'} {' '}
                        {
                            disableBTN == false ?
                                <a onClick={this.onClose} style={{ float: 'right', color: 'black' }}>
                                    <Icon type={'close'} />
                                </a>
                                : null
                        }
                    </div>
                }
                placement="right"
                closable={false}
                onClose={this.onClose}
                width={1000}
                visible={this.state.visible}>
                <Card>
                    <div className="window-wrapper js-autofocus js-tab-parent" >
                        <div className="card-detail-window u-clearfix">
                            <div className="window-header js-card-detail-header">

                                <div className="window-title">
                                    <h2 id="js-dialog-title" className="card-detail-title-assist js-title-helper" dir="auto">
                                        {taskDetail.taskTitle}

                                    </h2>
                                    {/* {
                                            taskDetail.status === "Pending"?
                                            <Col span={2}>
                                                    <div className="window-module-title-no-divider description-title">
                                                        <h3 className="u-inline-block">&nbsp;</h3>
                                                        <div attr="desc" className="editable">
                                                            <Button
                                                                type=""
                                                                htmlType="button"
                                                                title="Completed"
                                                                style={{
                                                                    marginBottom: 10,
                                                                    backgroundColor: 'green',
                                                                    color: 'white'
                                                                }}
                                                                onClick={
                                                                    () => {
                                                                        this.setState({taskCompleteFormVisible: true})
                                                                    }
                                                                }
                                                                disabled={disableBTN}
                                                                loading={this.props.loading}>
                                                                Mark Completed
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </Col>
                                            
                                            :null
                                        } */}
                                </div>
                                <div className="window-module-title-no-divider description-title">
                                    <h3 className="u-inline-block">Description</h3>
                                    <div attr="desc" className="editable">
                                        <p>{taskDetail.description}</p>
                                    </div>
                                </div>
                                <Row>
                                    <Col span={4}>
                                        <div className="window-module-title-no-divider description-title">
                                            <h3 className="u-inline-block">Created Date</h3>
                                            {
                                                taskDetail.createdByUser ?
                                                    <div attr="desc" className="editable">
                                                        <p>{moment(taskDetail.createdByUser.time).format('ll')}</p>
                                                    </div>
                                                    : null
                                            }
                                        </div>
                                    </Col>
                                    <Col span={4}>
                                        <div className="window-module-title-no-divider description-title">
                                            <h3 className="u-inline-block">Start Date</h3>
                                            <div attr="desc" className="editable">
                                                {
                                                    taskDetail.startDate ?
                                                        <p>{moment(taskDetail.startDate).format('ll')} {taskDetail.startTime}</p>
                                                        : <p>{moment(taskDetail.dueDate).format('ll')} {taskDetail.startTime}</p>
                                                }
                                            </div>
                                        </div>
                                    </Col>
                                    <Col span={4}>
                                        <div className="window-module-title-no-divider description-title">
                                            <h3 className="u-inline-block">Due Date</h3>
                                            <div attr="desc" className="editable">
                                                <p>{moment(taskDetail.dueDate).format('ll')}</p>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col span={4}>
                                        <div className="window-module-title-no-divider description-title">
                                            <h3 className="u-inline-block">Timeline</h3>
                                            <div attr="desc" className="editable">
                                                {
                                                    taskDetail.deadlineTime ?
                                                        <p>{moment(taskDetail.dueDate).format('ll')} {taskDetail.deadlineTime}</p> :
                                                        "NA"
                                                }
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={3}>
                                        <div className="window-module-title-no-divider description-title">
                                            <h3 className="u-inline-block">Status</h3>
                                            <div attr="desc" className="editable statuPriority" style={{ backgroundColor: backgroundColorMap }}>
                                                <p>{taskDetail.status}</p>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col span={3}>
                                        <div className="window-module-title-no-divider description-title">
                                            <h3 className="u-inline-block">Priority</h3>
                                            <div attr="desc" className="editable statuPriority" style={{ backgroundColor: priorityColorMap }}>
                                                <p>{taskDetail.priority}</p>
                                            </div>
                                        </div>
                                    </Col>
                                    {
                                        taskDetail.status == 'Pending' ?
                                            <>
                                                <Col span={3}>
                                                    <div className="window-module-title-no-divider description-title">
                                                        <h3 className="u-inline-block">&nbsp;</h3>
                                                        <div attr="desc" className="editable">
                                                            <Button
                                                                type=""
                                                                htmlType="button"
                                                                title="Completed"
                                                                style={{
                                                                    marginBottom: 10,
                                                                    backgroundColor: 'green',
                                                                    color: 'white'
                                                                }}
                                                                onClick={
                                                                    () => {
                                                                        this.setState({ taskCompleteFormVisible: true })
                                                                    }
                                                                }
                                                                disabled={disableBTN}
                                                                loading={this.props.loading}>
                                                                Completed
                                                                {/* <FaCheck /> */}
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </Col>
                                                {
                                                    userId == taskDetail.assignById ?
                                                        <Col span={3}>
                                                            <div className="window-module-title-no-divider description-title">
                                                                <h3 className="u-inline-block">&nbsp;</h3>
                                                                <div attr="desc" className="editable">
                                                                    <Button
                                                                        type=""
                                                                        htmlType="button"
                                                                        style={{
                                                                            marginBottom: 10,
                                                                            backgroundColor: 'blue',
                                                                            color: 'white'
                                                                        }}
                                                                        onClick={
                                                                            () => {
                                                                                this.setState({ forwardTaskVisible: true })
                                                                            }
                                                                        }
                                                                        title="Forward"
                                                                        disabled={disableBTN}
                                                                        loading={this.props.loading}>
                                                                        Forward
                                                                        {/* <FaForward /> */}
                                                                    </Button>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        : null}
                                                {
                                                    userId == taskDetail.assignById ?
                                                        <Col span={2}>
                                                            <div className="window-module-title-no-divider description-title">
                                                                <h3 className="u-inline-block">&nbsp;</h3>
                                                                <div attr="desc" className="editable">
                                                                    <Button
                                                                        type=""
                                                                        htmlType="button"
                                                                        style={{
                                                                            marginBottom: 10,
                                                                            backgroundColor: '#b8860b',
                                                                            color: 'white'
                                                                        }}
                                                                        onClick={
                                                                            () => {
                                                                                this.setState({ postponeTaskVisible: true })
                                                                            }
                                                                        }
                                                                        title="Postpone"
                                                                        disabled={disableBTN}
                                                                        loading={this.props.loading}>
                                                                        Postpone
                                                                        {/* <FaFastForward /> */}
                                                                    </Button>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        : null
                                                }
                                            </>
                                            : null
                                    }
                                    {
                                        taskDetail.status == 'Complete' ?
                                            <>
                                                {
                                                    userId == taskDetail.assignById ?
                                                        <Col span={2}>
                                                            <div className="window-module-title-no-divider description-title">
                                                                <h3 className="u-inline-block">&nbsp;</h3>
                                                                <div attr="desc" className="editable">
                                                                    <Button
                                                                        type=""
                                                                        htmlType="button"
                                                                        title="Reopen Task"
                                                                        style={{
                                                                            marginBottom: 10,
                                                                            backgroundColor: 'blue',
                                                                            color: 'white'
                                                                        }}
                                                                        onClick={
                                                                            () => {
                                                                                this.setState({ taskReopenForm: true })
                                                                            }
                                                                        }
                                                                        disabled={disableBTN}
                                                                        loading={this.props.loading}>
                                                                        Reopen
                                                                        {/* <FaBackward /> */}
                                                                    </Button>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        : null
                                                }

                                            </> : null
                                    }
                                </Row>
                                <Row>
                                    <Col span={5}>
                                        <div className="window-module-title-no-divider description-title">
                                            <h3 className="u-inline-block">Assigned By Name</h3>
                                            <div attr="desc" className="editable statuPriority" style={{ backgroundColor: 'orchid' }}>
                                                <p><b>{taskDetail.createdByUser ? taskDetail.createdByUser.name : 'NA'}</b></p>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col span={6}>
                                        <div className="window-module-title-no-divider description-title">
                                            <h3 className="u-inline-block">Assigned Name</h3>
                                            <div attr="desc" className="editable statuPriority" style={{ backgroundColor: 'darkgoldenrod' }}>
                                                <p><b>{taskDetail.assignName ? taskDetail.assignName : 'NA'}</b></p>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col span={6}>
                                        <div className="window-module-title-no-divider description-title">
                                            <h3 className="u-inline-block">
                                                {
                                                    userId == taskDetail.assignById ?
                                                        'Add More Assignee'
                                                        : 'More Assignees'
                                                }
                                            </h3>
                                            {
                                                userId == taskDetail.assignById ?
                                                    <Select
                                                        allowClear
                                                        style={{
                                                            width: 225,
                                                            marginRight: 16
                                                        }}
                                                        mode='multiple'
                                                        showSearch={true}
                                                        value={assignMoreIds}
                                                        placeholder="Select Option"
                                                        optionFilterProp="children"

                                                        onChange={assignMoreIds => {
                                                            this.setState(
                                                                {
                                                                    assignMoreIds: assignMoreIds
                                                                }, () => {
                                                                    this.saveMoreAssignee();
                                                                }
                                                            );
                                                        }}>
                                                        {allUsers.map((val, idn) => {
                                                            return (
                                                                <Option key={idn} value={val._id}>
                                                                    {val.name}
                                                                </Option>
                                                            )
                                                        })}
                                                    </Select>
                                                    :
                                                    <div>
                                                        {allUsers.map((val, idn) => {
                                                            return (
                                                                <div>
                                                                    {
                                                                        assignMoreIds.includes(val._id) ?
                                                                            <div><b>{val.name}</b></div>
                                                                            : null
                                                                    }
                                                                </div>
                                                            )
                                                        })}
                                                    </div>
                                            }
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div className="window-main-col">
                                <div className="window-module-title window-module-title-no-divider card-detail-activity">
                                    <h3>Activity</h3>
                                </div>
                                <div className="js-fill-card-detail-desc">
                                    <Form onSubmit={this.saveNote} style={{ marginTop: 8 }}>
                                        <GetAllFormFields
                                            apiurl={LAPI_URL}
                                            inputSchema={inputTypes}
                                            refresh={this.refreshFxn}
                                            getFieldDecorator={getFieldDecorator}
                                        />
                                        <Button
                                            type=""
                                            htmlType="submit"
                                            style={{
                                                marginBottom: 10,
                                                backgroundColor: 'green',
                                                color: 'white'
                                            }}
                                            disabled={disableBTN}
                                            loading={this.props.loading}>
                                            SAVE
                                        </Button>
                                    </Form>
                                </div>
                                <div className="window-module">
                                    {
                                        taskDetail.notes && taskDetail.notes.length ?
                                            taskDetail.notes.map((note, index) => {
                                                return (
                                                    <div className="phenom mod-attachment-type" key={index}>
                                                        <div className="phenom-desc">
                                                            <span className="inline-member js-show-mem-menu">
                                                                <span className="u-font-weight-bold">{note.createdByUser.name}</span>
                                                            </span>
                                                            <span className="phenom-date quiet">{moment(note.createdByUser.time).format('MMM DD, h:mm a')}</span>
                                                        </div>
                                                        <div className="phenom-meta quiet">
                                                            <div className="action-comment can-edit can-view-video markeddown js-comment">
                                                                <div className="current-comment js-friendly-links js-open-card">
                                                                    {note.image && note.image[0] && (
                                                                        /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(note.image[0].url)
                                                                            ? (
                                                                                <img
                                                                                    style={{ height: '240px', width: '100%' }}
                                                                                    src={`${LAPI_URL}/file/${note.image[0].url}`}
                                                                                    alt="Note attachment"
                                                                                />
                                                                            )
                                                                            : (
                                                                                <a
                                                                                    href={`${LAPI_URL}/file/${note.image[0].url}`}
                                                                                    download
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer"
                                                                                >
                                                                                    Download Attachment
                                                                                </a>
                                                                            )
                                                                    )}
                                                                    <p>{note.description}</p>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                )
                                            })
                                            : null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </Card>
                <Drawer
                    title="FORWARD TASK"
                    width={520}
                    closable={false}
                    onClose={this.onForwardTaskClose}
                    visible={this.state.forwardTaskVisible}>
                    <div style={{ marginLeft: 20, marginTop: 25 }}>
                        <Form.Item label="Search By User" {...formItemLayout}>
                            <Select
                                defaultValue={this.state.assignId}
                                showSearch
                                allowClear
                                style={{
                                    width: 214,
                                    paddingRight: 16,
                                    paddingLeft: 9
                                }}
                                value={this.state.forwardUserId}
                                placeholder="Select User"
                                onChange={forwardUserId => {
                                    this.setState({ forwardUserId }, () => {
                                        // this.taskTable.current.reload()
                                    })
                                }}
                                filterOption={(input, option) => {
                                    return (
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    )
                                }}>
                                {allUsers &&
                                    allUsers.map((val, idn) => {
                                        return (
                                            <Option key={idn} value={val._id}>
                                                {val.name}
                                            </Option>
                                        )
                                    })}
                            </Select>
                        </Form.Item>
                        <Form.Item label="TaskTitle" {...formItemLayout}>
                            <Input
                                placeholder="Task Title"
                                value={this.state.taskTitle}
                                onChange={taskTitle => {
                                    taskTitle = taskTitle.target.value
                                    this.setState({ taskTitle })
                                }}
                            />
                        </Form.Item>

                        <Form.Item label="DueDate" {...formItemLayout}>
                            <DatePicker
                                defaultValue={
                                    this.state.taskDetail &&
                                    moment(this.state.taskDetail.dueDate, 'YYYY-MM-DD')
                                }
                                onChange={dueDate => {
                                    this.setState({
                                        dueDate: dueDate && moment(dueDate).format('YYYY-MMM-DD')
                                    })
                                }}
                                disabledDate={d => !d || d.isBefore(moment().add(-1, 'day'))}
                            />
                        </Form.Item>

                        <Form.Item label="Timeline" {...formItemLayout}>
                            <TimePicker
                                defaultValue={this.state.taskDetail && this.state.taskDetail.deadlineTime ?
                                    moment(this.state.taskDetail.deadlineTime, "HH:mm")
                                    : null}
                                format='HH:mm'
                                onChange={deadlineTime => {
                                    this.setState({
                                        deadlineTime: deadlineTime && moment(deadlineTime).format('HH:MM')
                                    })
                                }}

                            />
                        </Form.Item>

                        <Form.Item label="Priority" {...formItemLayout}>
                            <Select
                                defaultValue={
                                    this.state.taskDetail && this.state.taskDetail.priority
                                }
                                style={{ width: 100 }}
                                onChange={priority => {
                                    this.setState({ priority: priority && priority.toString() })
                                }}>
                                <Option value="High">High</Option>
                                <Option value="Low">Low</Option>
                                <Option value="Normal">Normal</Option>
                            </Select>
                        </Form.Item>
                        <Form.Item label="Description" {...formItemLayout}>
                            <Input.TextArea
                                placeholder="Description"
                                rows="10"
                                value={this.state.description}
                                onChange={description => {
                                    description = description.target.value
                                    this.setState({ description })
                                }}
                            />
                        </Form.Item>

                        <Button
                            type="primary"
                            htmlType="submit"
                            disabled={!this.state.forwardUserId}
                            style={{ marginLeft: 100, backgroundColor: 'green' }}
                            loading={this.props.loading}
                            onClick={async () => {
                                if (taskDetail && this.state.forwardUserId) {
                                    let x = await Request.taskFullStatus({
                                        _id: taskDetail._id,
                                        status: 'Forward',
                                        note: this.state.description
                                    })

                                    let y = await Request.addTask({
                                        assignId: this.state.forwardUserId,
                                        taskTitle: this.state.taskTitle
                                            ? this.state.taskTitle
                                            : taskDetail.taskTitle,
                                        description: this.state.description
                                            ? this.state.description
                                            : taskDetail.description,
                                        priority: this.state.priority
                                            ? this.state.priority
                                            : taskDetail.priority,
                                        status: this.state.status
                                            ? this.state.status
                                            : taskDetail.status,
                                        dueDate: this.state.dueDate
                                            ? this.state.dueDate
                                            : taskDetail.dueDate,
                                        deadlineTime: this.state.deadlineTime ? this.state.deadlineTime : null
                                    })
                                    if (!y.error) {
                                        notification.success({ message: 'Task Forwarded' })
                                    }
                                    this.getNotes();
                                }

                                this.setState({
                                    forwardTaskVisible: false,
                                    dueDate: '',
                                    deadlineTime: null,
                                    priority: '',
                                    description: '',
                                    taskTitle: ''
                                })
                            }}>
                            Forward
                        </Button>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={this.props.loading}
                            style={{ marginLeft: 10 }}
                            onClick={() => {
                                this.setState({ forwardTaskVisible: false })
                            }}>
                            CLOSE
                        </Button>
                    </div>
                </Drawer>
                <Drawer
                    title="PostPone TASK"
                    width={520}
                    closable={false}
                    onClose={this.onPostponeTaskClose}
                    visible={this.state.postponeTaskVisible}>
                    <div style={{ marginLeft: 20, marginTop: 25 }}>

                        <Form.Item label="DueDate" {...formItemLayout}>
                            <DatePicker
                                defaultValue={
                                    this.state.taskDetail &&
                                    moment(this.state.taskDetail.dueDate, 'YYYY-MM-DD')
                                }
                                onChange={dueDate => {
                                    this.setState({
                                        dueDate: dueDate
                                    })
                                }}
                                disabledDate={d => !d || d.isBefore(moment().add(-1, 'day'))}
                            />
                        </Form.Item>
                        <Form.Item label="Timeline" {...formItemLayout}>
                            <TimePicker
                                defaultValue={
                                    this.state.deadlineTime ? moment(this.state.deadlineTime, 'HH:mm') : null
                                }
                                format='HH:mm'
                                onChange={deadlineTime => {
                                    this.setState({
                                        deadlineTime: deadlineTime
                                    })
                                }}
                            />
                        </Form.Item>

                        <Button
                            type="primary"
                            htmlType="submit"
                            style={{ marginLeft: 100, backgroundColor: 'green' }}
                            loading={this.props.loading}
                            onClick={async () => {
                                if (taskDetail) {
                                    let taskDetails = {
                                        _id: taskDetail._id,
                                        dueDate: this.state.dueDate
                                            ? this.state.dueDate
                                            : taskDetail.dueDate,
                                        deadlineTime: this.state.deadlineTime ? this.state.deadlineTime : null
                                    }
                                    let x = await Request.updatePostponDate(taskDetails)
                                    if (!x.error) {
                                        notification.success({ message: 'Task Postponed' })
                                    }
                                    this.getNotes();
                                }

                                this.setState({
                                    postponeTaskVisible: false,
                                    dueDate: '',
                                    deadlineTime: null,
                                })
                            }}>
                            Postpone
                        </Button>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={this.props.loading}
                            style={{ marginLeft: 10 }}
                            onClick={() => {
                                this.setState({ postponeTaskVisible: false })
                            }}>
                            CLOSE
                        </Button>
                    </div>
                </Drawer>
                <Drawer
                    title="COMPLETE TASK"
                    width={520}
                    closable={false}
                    onClose={this.onTaskCompleteClose}
                    visible={this.state.taskCompleteFormVisible}>
                    <div style={{ marginLeft: 20, marginTop: 25 }}>
                        <label>
                            {' '}
                            <span style={{ color: 'red' }}>TASK TITLE : </span>{' '}
                            {taskDetail && taskDetail.taskTitle}
                        </label>
                        <br />
                        <br />
                        <label>
                            <span style={{ color: 'red' }}> DUE DATE : </span>{' '}
                            {taskDetail && moment(taskDetail.dueDate).format('DD/MM/YY')}
                        </label>
                        <br />
                        <br />

                        <form>
                            <Input.TextArea
                                placeholder="Comment Box"
                                value={this.state.taskCompleteNote}
                                style={{ width: 350, marginTop: 10, marginBottom: 20 }}
                                rows={4}
                                onChange={record => {
                                    record = record.target.value
                                    this.setState({ taskCompleteNote: record && record.toString() })
                                }}
                            />
                        </form>

                        <Button
                            type="primary"
                            htmlType="submit"
                            style={{ backgroundColor: 'green' }}
                            loading={this.props.loading}
                            onClick={async () => {
                                let x = await Request.taskFullStatus({
                                    _id: taskDetail._id,
                                    status: 'Complete',
                                    note: this.state.taskCompleteNote
                                })
                                if (!x.error) {
                                    notification.success({
                                        message: 'Task Completed Successfully.'
                                    })
                                }
                                this.getNotes();

                                this.setState({ taskCompleteFormVisible: false, taskCompleteNote: '' })
                            }}>
                            Ok
                        </Button>

                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={this.props.loading}
                            style={{ marginLeft: 10 }}
                            onClick={() => {
                                this.setState({ taskCompleteFormVisible: false })
                            }}>
                            CLOSE
                        </Button>
                    </div>
                </Drawer>
                <Drawer
                    title="Reopen TASK"
                    width={520}
                    closable={false}
                    onClose={this.onTaskReopenClose}
                    visible={this.state.taskReopenForm}>
                    <div style={{ marginLeft: 20, marginTop: 25 }}>

                        <Form.Item label="DueDate" {...formItemLayout}>
                            <DatePicker
                                defaultValue={
                                    this.state.taskDetail &&
                                    moment(this.state.taskDetail.dueDate, 'YYYY-MM-DD')
                                }
                                onChange={dueDate => {
                                    this.setState({
                                        dueDate: dueDate
                                    })
                                }}
                                disabledDate={d => !d || d.isBefore(moment().add(-1, 'day'))}
                            />
                        </Form.Item>

                        <Button
                            type="primary"
                            htmlType="submit"
                            style={{ marginLeft: 100, backgroundColor: 'green' }}
                            loading={this.props.loading}
                            onClick={async () => {
                                if (taskDetail) {
                                    let x = await Request.reopenTask({
                                        _id: taskDetail._id,
                                        dueDate: this.state.dueDate
                                            ? this.state.dueDate
                                            : taskDetail.dueDate
                                    })
                                    if (!x.error) {
                                        notification.success({ message: x.msg })
                                    }
                                    this.getNotes();
                                }

                                this.setState({
                                    taskReopenForm: false,
                                    dueDate: ''
                                })
                            }}>
                            Reopen
                        </Button>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={this.props.loading}
                            style={{ marginLeft: 10 }}
                            onClick={() => {
                                this.setState({ taskReopenForm: false })
                            }}>
                            CLOSE
                        </Button>
                    </div>
                </Drawer>
            </Drawer>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TaskViewer)